import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import clsx from 'clsx';
import { getFreezeProps } from "./table-freeze.utils";
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
import { useTranslation } from 'react-i18next';
import { nstable } from "../../../i18n/namespaces";
import '@isyc-react/design/main';
import "./table.style.scss";
export const TableHead = props => {
  const {
    instance
  } = props;
  const {
    headerGroups,
    visibleColumns
  } = instance;
  const {
    t
  } = useTranslation(nstable.common);
  const headPropGetter = React.useCallback((headers, column, index) => {
    const grouped = visibleColumns.some(vc => vc.isGrouped);
    const style = {
      minWidth: column.minWidth,
      width: column.width,
      maxWidth: column.maxWidth
    };
    const className = '';
    if (!grouped && column.freeze) {
      const {
        style: freezeStyle,
        className: freezeClassName
      } = getFreezeProps(headers, index);
      return {
        className: clsx(className, 'column-freeze-header', freezeClassName),
        style: _objectSpread(_objectSpread({}, style), freezeStyle)
      };
    }
    return {
      className,
      style
    };
  }, [visibleColumns]);
  return /*#__PURE__*/React.createElement("thead", null, headerGroups.map((headerGroup, i) => /*#__PURE__*/React.createElement("tr", _extends({}, headerGroup.getHeaderGroupProps(), {
    key: i
  }), headerGroup.headers.map((column, index) => /*#__PURE__*/React.createElement("th", _extends({}, column.getHeaderProps(headPropGetter(headerGroup.headers, column, index)), {
    key: index
  }), /*#__PURE__*/React.createElement("div", {
    className: "column-head-content"
  }, column.canGroupBy && /*#__PURE__*/React.createElement(OverlayTrigger, {
    delay: {
      show: 500,
      hide: 0
    },
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, t('table.header.group.toggle'))
  }, /*#__PURE__*/React.createElement("span", _extends({}, column.getGroupByToggleProps({
    title: undefined
  }), {
    className: "column-head-group-by"
  }), column.isGrouped ? /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-right"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-left"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "column-head-header"
  }, column.canFilter ? column.render('Filter') : column.render('Header')), column.canSort && /*#__PURE__*/React.createElement(OverlayTrigger, {
    delay: {
      show: 500,
      hide: 0
    },
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, t('table.header.sort.toggle'))
  }, /*#__PURE__*/React.createElement("span", _extends({}, column.getSortByToggleProps({
    title: undefined
  }), {
    className: "column-head-sort-by"
  }), column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-menu-up"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-menu-down"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-menu-swap"
  })))))))));
};